import React, { useEffect, useState } from "react";
import { useOrdersContext } from "../../contexts/OrdersContext";
import { formatPrice } from "../../MesPages/Panier/Cart";
import { Spinner } from "react-bootstrap";

const EncoursComponent = ({ totalAmount, isLoading }) => {
    const clisolde = JSON.parse(localStorage.getItem("userData")).STR_SOCSOLDE;
    const { sumAmountOrders, fetchUserSumAmountOrders, isOrdersLoading } = useOrdersContext();
    const showLoader = isOrdersLoading || isLoading;

     // Les données d'exemple
     const [data, setData] = useState({
        encours: clisolde,
        panier: totalAmount,
        commande: 0,
    });



    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userData"));
        if (user) {
            fetchUserSumAmountOrders();
        }
    }, []);

    useEffect(() => {
        if (sumAmountOrders !== null) {
            const amountOrdered = Math.min(totalAmount, sumAmountOrders); // Commande plafonnée au montant du panier
            setData((prevData) => ({
                ...prevData,
                panier: Math.max(totalAmount - amountOrdered, 0), // Mise à jour du panier
                commande:  sumAmountOrders, // Mise à jour des commandes passées
            }));
        }
    }, [sumAmountOrders, totalAmount]);

    // Calcul dynamique de l'encours restant
    //const encoursRestant = clisolde > 0 ? clisolde - data.panier - data.commande : 0;
    //const encoursRestant = clisolde - sumAmountOrders;

    const encoursRestant = clisolde - totalAmount - (sumAmountOrders || 0);

    useEffect(() => {
        console.log("Panier avant mise à jour:", totalAmount);
        console.log("SOLDE CLIENT :", clisolde);
        console.log("Commande récupérée:", sumAmountOrders);
        console.log("Nouvel encours:", encoursRestant);
    }, [sumAmountOrders, totalAmount]);

    // --- Calcul sécurisé des pourcentages pour la jauge ---
    const safeClisolde = clisolde || 1; 
    const baseTotal = totalAmount + (data.commande || 0);
    // Si on dépasse le plafond, la jauge se base sur le total réel pour ne pas déborder (width > 100%)
    const gaugeTotal = Math.max(safeClisolde, baseTotal);

    let pctCommande = ((data.commande || 0) / gaugeTotal) * 100;
    let pctPanier = (totalAmount / gaugeTotal) * 100;
    let pctRestant = gaugeTotal > baseTotal ? ((gaugeTotal - baseTotal) / gaugeTotal) * 100 : 0;

    // Assurer une visibilité minimale pour la jauge du panier (au moins 2%) si un montant existe
    if (totalAmount > 0 && pctPanier < 2) {
        const diff = 2 - pctPanier;
        pctPanier = 2;
        if (pctRestant > diff) {
            pctRestant -= diff;
        } else if (pctCommande > diff) {
            pctCommande -= diff;
        }
    }
    

    return (
        <div
            style={styles.container}
            className="responsive-encours order-md-4 order-2"
        >
            {isOrdersLoading ? (
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "65px", padding: "10px 0" }}>
                    <i className="fas fa-spinner fa-spin" style={{ color: "#3B5998", fontSize: "24px", marginBottom: "5px" }}></i>
                    <span style={{ color: "#3B5998", fontSize: "13px", fontWeight: "bold" }}>Chargement...</span>
                </div>
            ) : (
                <>
                    <div style={styles.barContainerParent}>
                        <span style={styles.meter}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="34"
                                height="34"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm7.41 13H4.59A7.875 7.875 0 0 1 4 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.875 7.875 0 0 1-.59 3z"></path>
                                <path d="M10.939 12.939a1.53 1.53 0 0 0 0 2.561 1.53 1.53 0 0 0 2.121-.44l3.962-6.038a.034.034 0 0 0 0-.035.033.033 0 0 0-.045-.01l-6.038 3.962z"></path>
                            </svg>
                        </span>
                        <div style={styles.barContainer}>
                            {data.commande !== null && (
                                <div
                                    style={{
                                        ...styles.bar,
                                        ...styles.commande,
                                        width: `${pctCommande}%`,
                                    }}
                                >
                                    {/* Commandes */}
                                </div>
                            )}
                            {totalAmount > 0 && (
                                <div
                                    style={{
                                        ...styles.bar,
                                        ...styles.panier,
                                        width: `${pctPanier}%`,
                                    }}
                                >
                                    {/* Panier */}
                                </div>
                            )}
                            {pctRestant > 0 && (
                                <div
                                    style={{
                                        ...styles.bar,
                                        ...styles.restant,
                                        width: `${pctRestant}%`,
                                    }}
                                >
                                    {/* En cours restant */}
                                </div>
                            )}
                        </div>
                    </div>

                    <div style={styles.footer}>
                        <span>
                            Commandes: {data.commande !== null ? formatPrice(data.commande) + " FCFA" : "0 FCFA"}
                        </span>
                        <span>
                            Panier: {totalAmount ? formatPrice(totalAmount) : 0} FCFA
                        </span>
                        <span style={{ color: encoursRestant < 0 ? "#dc3545" : "#336699" }}>
                            Encours:{" "}
                            {clisolde === null || clisolde === 0
                                ? "Pas d'encours"
                                : encoursRestant >= 0
                                    ? `${formatPrice(encoursRestant)} FCFA`
                                    : `- ${formatPrice(Math.abs(encoursRestant))} FCFA dépassé`
                            }
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

// Styles en objet JavaScript
const styles = {
    container: {
        backgroundColor: "#f9f9f9",
        padding: "15px",
        borderRadius: "10px",
        width: "100%",
        // margin: "0 auto",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    barContainerParent: {
        position: "relative",
        paddingLeft: "40px",
    },
    barContainer: {
        display: "flex",
        height: "25px",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#f1f1f1",
        marginBottom: "10px",
    },
    bar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "12px",
        whiteSpace: "nowrap",
    },
    commande: {
        backgroundColor: "#6c92dd",
    },
    panier: {
        backgroundColor: "#3656a1",
    },
    restant: {
        backgroundColor: "#bad3fb",
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "15px",
        fontSize: "13px",
        color: "#336699",
        fontWeight: "bold",
    },
    meter: {
        position: "absolute",
        left: "0",
        bottom: "-12px",
    },
};

export default EncoursComponent;
